import React from "react";
import { useTranslation } from "react-i18next";
import { StatusDisplay } from "../../loads/partials/LoadStatusChip";

function SpotLoadStatus(props: any) {
    const { status, label, textable, chip } = props;
    const { t } = useTranslation();

    if ( status === 'pending' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-red-500"
                label={ label ? label : t('pending') }
                badgeSeverity="danger"
            />
        );
    }

    if ( status === 'announced' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-primary-500"
                label={ label ? label : t('announced') }
                badgeSeverity="info"
            />
        );
    }

    if ( status === 'in-transit' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-yellow-500"
                label={ label ? label : t('in transit') }
                badgeSeverity="warning"
            />
        );
    }

    if ( status === 'delivered' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('delivered') }
                badgeSeverity="success"
            />
        );
    }

    if ( status === 'archived' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('archived') }
                badgeSeverity="success"
            />
        );
    }

    return (
        <span>-</span>
    );
}

export default SpotLoadStatus;
